import { z } from 'zod';
import { LocaleSchema } from './common';

/**
 * `form`: personal form link (/f/:token, target = form id, meta.contactId);
 * `form_share`: public share code of a form (/s/:code, target = form id).
 */
export const PUBLIC_TOKEN_KINDS = [
  'review',
  'unsubscribe',
  'feedback',
  'preview',
  'form',
  'form_share',
] as const;
export type PublicTokenKind = (typeof PUBLIC_TOKEN_KINDS)[number];

/** Opaque public tokens: 32 random bytes base64url = 43 chars. */
export const PublicTokenSchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/);

export const ReviewLandingResponseSchema = z.object({
  businessName: z.string(),
  locationName: z.string(),
  locale: LocaleSchema,
  firstName: z.string().nullable(),
  googleReviewUrl: z.string().nullable(),
  texts: z.object({ question: z.string(), likedMessage: z.string(), dislikedMessage: z.string() }),
  state: z.object({
    sentiment: z.enum(['liked', 'disliked']).nullable(),
    feedbackSubmitted: z.boolean(),
    expired: z.boolean(),
  }),
});
export type ReviewLandingResponse = z.infer<typeof ReviewLandingResponseSchema>;

export const ReviewSentimentRequestSchema = z.object({ sentiment: z.enum(['liked', 'disliked']) });

export const PrivateFeedbackRequestSchema = z.object({
  message: z.string().trim().min(1).max(4000),
  wantsContact: z.boolean().default(false),
});

export const UnsubscribeRequestSchema = z.object({
  channel: z.enum(['email', 'sms']).optional(),
});
